import React 				from 'react';
import BLComponent 			from '../core/_BLComponent.jsx';
import SellerStoreLockup 	from '../common/_SellerStoreLockup.jsx';

export default class ModalStoreRow extends BLComponent
{
	constructor(props) 
	{
		super(props);
	}

	render() 
	{
		const {location, name, feedbackRank, items} = this.props.store;
		const showFlag = this.props.showFlag || true;

		return (
			<div className="item-finder-modal__store">
				<div className="l-margin-right--sm">
					<SellerStoreLockup classes="l-margin-bottom--sm" isBold={false} details={{ flag: showFlag ? location.country_code : null, storeName: name, feedbackRank: feedbackRank }}/>
					<small className="text--note">{location.state != null && location.state != "" ? location.state + ", " : "" }{location.country}</small>
				</div>
				<div className="text--right">
					<strong className="l-block l-margin-bottom--sm">{items.approx ? '~' : ''}{blapp.format.formatMoney(items.total)}</strong>
					<small className="text--note">{$T('LOT',[items.lots])}</small>
				</div>
			</div>
		);
	}

	static getStorePropFromBLMInvFinderStoreResult( dmStoreResult )
	{
		return ModalStoreRow.getStorePropFromBLMStoreBasic( dmStoreResult.dmStore, dmStoreResult.mTotalItemNetPriceInDisplayCurrency, _.size( dmStoreResult.mapInvs ) );
	}

	static getStorePropFromBLMStoreBasic( dmStoreBasic, mTotalPriceByDisplayCurrency, nTotalLots )
	{
		var	stateInfo	= blapp.country.getStateLegacy( dmStoreBasic.idState );
		var countryInfo	= blapp.country.get( dmStoreBasic.codeCountry );

		return (
			{
				location:		{
									state:			stateInfo != null ? stateInfo.strStateName : ""
								,	country:		countryInfo != null ? countryInfo.strCountryName : "Unknown"
								,	country_code:	dmStoreBasic.codeCountry
								}
			,	name:			dmStoreBasic.strStoreName
			,	feedbackRank:	blapp.util.getLevelFromFeedbackScore( dmStoreBasic.nFeedbackScore )
			,	items:			{
									total:		mTotalPriceByDisplayCurrency
								,	lots:		nTotalLots
								,	approx:		dmStoreBasic.idStoreCurrency != blapp.session.idCurrencyDetected
								}
			}
		);
	}
}

var $T = BLComponent.createTextMap( 
		{
			"LOT":
			{
				"en":	"{{$0?s=( lot):( lots)}}"
			,	"kr":	"{{$0}} 품목"
			,	"es":	"{{$0?s=( lote):( lotes)}}"
			}
		}
);